export const FUNDING_METHODS = [
  { value: 'ACH', label: 'ACH' },
  { value: 'CHECK', label: 'Paper Check' },
  { value: 'WIRE', label: 'Wire Transfer' },
];
